import { render, staticRenderFns } from "./cv-number-input-skeleton.vue?vue&type=template&id=4c238f72&"
import script from "./cv-number-input-skeleton.vue?vue&type=script&lang=js&"
export * from "./cv-number-input-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports